const stylesheets = new Map<string, Promise<void>>();

export function loadStylesheet(document: Document, href: string): Promise<void> {
  const existing = stylesheets.get(href);
  if (existing) {
    return existing;
  }

  const loaded = new Promise<void>((resolve) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = () => resolve();
    link.onerror = () => {
      stylesheets.delete(href);
      link.remove();
      resolve();
    };
    document.head.insertBefore(link, document.head.querySelector('link[rel="stylesheet"], style'));
  });

  stylesheets.set(href, loaded);
  return loaded;
}
